import { render, staticRenderFns } from "./Id.vue?vue&type=template&id=7c08c9e2"
import script from "./Id.vue?vue&type=script&setup=true&lang=js"
export * from "./Id.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports